import { createApiRef } from '@backstage/core-plugin-api';
import { MattaverseOrchestrationClient } from './MattaverseOrchestrationClient';

/**
 * API reference for the Mattaverse Orchestration client
 */
export const mattaverseOrchestrationApiRef =
  createApiRef<MattaverseOrchestrationClient>({
    id: 'plugin.mattaverse-orchestration.service',
  });

export { MattaverseOrchestrationClient };
